__turbopack_context__.v({
  "link": "ResultGroup-module__dji2wG__link",
  "resultInformation": "ResultGroup-module__dji2wG__resultInformation",
  "resultItem": "ResultGroup-module__dji2wG__resultItem",
});
